<template>
    <div class="container">
        <menu-list></menu-list>
        <div class="main">
            <div class="main-content">
                <div class="main-left ">
                    <div class="product-wrap boxshadow2">
                        <div class="item">
                            <div class="product-img">
                                <img :src="productDefault.image" alt="">
                            </div>
                            <div class="product-attached">
                            <span v-for="(item,index) in productDefault.attachments" :key="`attached_${index}`">
                                <img v-if="index<6" :src="item" alt="" width="44px" height="44px">
                            </span>
                            </div>
                            <div class="product-price">
                                <span>${{productDefault.price}}</span>
                            </div>
                            <div class="product-title" :title="productDefault.title">
                                {{productDefault.title}}
                            </div>
                            <div class="product-comments">
                                <span>9888+ </span> comments
                            </div>
                            <div class="product-shop">
                                <span>
                                    {{productDefault.brand}}
                                    <i class="iconfont iconownbrand"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="main-right">
                    <div class="basics-section boxshadow2">
                        <div class="basics-section-main">
                            <div class="head">
                                <span class="head-1">价格设置</span>
                                <span class="head-2">Price Setting</span>
                            </div>
                            <div class="cont">
                                <el-form :inline="true" ref="editProductForm" :model="product" label-width="180px" size="big" class="edit-product" :rules="productRules">
                                    <el-form-item label="Price($)" prop="price">
                                        <template slot="label">
                                            <span>Price($)</span>
                                            <i class="el-icon-question commonStyle" @click="showInfo('Price')"></i>
                                        </template>
                                        <el-input v-model="product.price" type="number"></el-input>
                                    </el-form-item>
                                    <el-form-item label="MSRP($)" prop="msrp">
                                        <template slot="label">
                                            <span>MSRP($)</span>
                                            <i class="el-icon-question commonStyle" @click="showInfo('MSRP')"></i>
                                        </template>
                                        <el-input v-model="product.msrp" type="number"></el-input>
                                    </el-form-item>
                                    <el-form-item label="Logistic($)" prop="logistic">
                                        <template slot="label">
                                            <span>Logistic($)</span>
                                            <i class="el-icon-question commonStyle" @click="showInfo('Logistic')"></i>
                                        </template>
                                        <el-input v-model="product.logistic" type="number"></el-input>
                                    </el-form-item>
                                    <el-form-item label="Inventory" prop="inventory">
                                        <template slot="label">
                                            <span>Inventory</span>
                                            <i class="el-icon-question commonStyle" @click="showInfo('Inventory')"></i>
                                        </template>
                                        <el-input v-model="product.inventory" type="number"></el-input>
                                    </el-form-item>
                                    <el-form-item label="TimeLiness(Day)" prop="timeliness">
                                        <template slot="label">
                                            <span>TimeLiness(Day)</span>
                                            <i class="el-icon-question commonStyle" @click="showInfo('TimeLiness')"></i>
                                        </template>
                                        <el-input v-model="product.timeliness" type="number"></el-input>
                                    </el-form-item>
                                    <el-form-item label="UPC" prop="upc">
                                        <template slot="label">
                                            <span>UPC</span>
                                            <i class="el-icon-question commonStyle" @click="showInfo('UPC')"></i>
                                        </template>
                                        <el-input v-model="product.upc"></el-input>
                                    </el-form-item>
                                    <el-form-item label="Profits">
                                        <template slot="label">
                                            <span>Profits</span>
                                            <i class="el-icon-question commonStyle" @click="showInfo('Profits')"></i>
                                        </template>
                                        <el-input :disabled="true" v-model="product.profits"></el-input>
                                    </el-form-item>
                                </el-form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="main-footer">
                <div class="btnn active" @click="$router.push('/MaritimeSilkRoad/imgEdit')">
                    上一步
                </div>
                <div class="btnn active" @click="next()">
                    下一步
                </div>
            </div>
        </div>
        <div class="foot">
            闽ICP备17025076号-2 <span style="margin: 0 20px"></span>©2017-{{new Date().getFullYear()}} All rights reserved.
        </div>
        <el-dialog
                class="modalInfo"
                title="提示"
                :visible.sync="dialogInfo"
                top="1%"
                width="60%">
            <div slot="title">
                <div class="modalTitle">
                    {{modalData.name}}
                </div>
            </div>
            <div class="modalInfoContent">
                <div class="section" v-for="(item,index) in modalData.content" :key="index">
                    <div class="tit">
                        {{item.title}}
                    </div>
                    <div class="details" v-if="item.content.length>0">
                        <p v-for="(itemm,indexx) in item.content" :key="`${index}_${indexx}`">
                            {{itemm}}
                        </p>
                    </div>
                </div>
                <div class="example" v-if="modalData.example && modalData.example.length>0">
                    <h1>优秀的案例</h1>
                    <p v-for="(item,index) in modalData.example" :key="`e_${index}`">
                        {{item}}
                    </p>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "baseEdit",
        data() {
            return {
                dialogInfo:false,
                modalData:{},
                add: {
                    tags: '',
                    keywords: '',
                },
                product: {
                    price:'',
                    msrp:'',
                    logistic:'',
                    inventory:'',
                    timeliness:'',
                    upc:'',
                    profits:'',
                },
                productRules: {
                    price:[
                        {required: true, message: '必填项', trigger: 'blur'},
                    ],
                    msrp:[
                        {required: true, message: '必填项', trigger: 'blur'},
                    ],
                    logistic:[
                        {required: true, message: '必填项', trigger: 'blur'},
                    ],
                    inventory:[
                        {required: true, message: '必填项', trigger: 'blur'},
                    ],
                    timeliness:[
                        {required: true, message: '必填项', trigger: 'blur'},
                    ],
                    upc:[
                        {required: true, message: '必填项', trigger: 'blur'},
                    ],
                    profits:'',
                }
            }
        },
        created() {
            let $product = JSON.parse(JSON.stringify(this.$store.state.template.edit))
            Object.assign(this.product,$product)
        },
        computed:{
            productDefault:function () {
                return JSON.parse(JSON.stringify(this.$store.state.template.default))
            }
        },
        watch:{
            product:{
                handler:function (newv) {
                    if (this.product.price && this.product.logistic) {
                        this.product.profits = ((parseFloat(this.product.price) + parseFloat(this.product.logistic)) * 0.85).toFixed(2);
                    }
                    this.$store.commit('setData',{setKey:'template.edit',value:newv})
                },
                deep:true
            }
        },
        methods: {
            showInfo(v) {
                this.dialogInfo = true
                this.modalData = this.$store.state.productInfo[v]
            },
            inputFocus(e) {
                e.target.lastElementChild.focus()
            },
            addItem(name) {
                if (this.add[name].trim() === '') return false;
                this.product[name].push(this.add[name]);
                this.add[name] = '';
            },
            removeItem(item,arrayName) {
                let index = this.product[arrayName].indexOf(item)
                if (index !== -1) {
                    this.product[arrayName].splice(index, 1)
                }
            },
            next(){
                this.$refs['editProductForm'].validate((valid) => {
                    if (valid) {
                        this.$router.push('/MaritimeSilkRoad/logisticsEdit')
                    } else {
                        this.$message.error('有必填项未填写，请检查后重试')
                        return false;
                    }
                });
            }
        }
    }
</script>

<style scoped lang="scss">

    .main {
        div.main-content {
            display: flex;

            div.main-left {
                display: flex;
                flex-direction: column;
                margin-right: 28px;
                width: 452px;

                div.product-wrap {
                    background: #FFFFFF;
                    border-radius: 16px;

                    .item {
                        width: 388px;
                        height: 712px;
                        margin: 54px 32px;
                        border: 2px solid #adadad;
                        border-radius: 20px;
                        box-sizing: border-box;
                        padding: 24px;
                        /*background: #f5f5f5;*/
                        display: flex;
                        flex-direction: column;
                        position: relative;

                        > .product-img {
                            width: 100%;
                            height: 0;
                            padding-bottom: 100%;
                            overflow: hidden;
                            position: relative;

                            img {
                                position: absolute;
                                top: 50%;
                                left: 50%;
                                transform: translate(-50%, -50%);
                                max-width: 100%;
                                height: 100%;
                            }
                        }

                        > .product-attached {
                            margin: 12px 0;
                            display: flex;
                            align-items: center;
                            justify-content: flex-start;

                            span {
                                display: inherit;
                                width: 44px;
                                height: 44px;
                                margin-right: 12px;

                                > img {
                                    object-fit: cover;

                                    &:last-child {
                                        margin-right: 0;
                                    }
                                }
                            }
                        }

                        > .product-price {
                            font-size: 34px;
                            margin: 18px 0;
                            color: #E50011;

                        }

                        > .product-title {

                            font-size: 18px;
                            color: #595757;
                            text-overflow: ellipsis;
                            line-height: 20px;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 2;
                            overflow: hidden;
                            margin-bottom: 18px;
                        }

                        > .product-comments {
                            font-size: 18px;
                            line-height: 20px;
                            color: #adadad;
                            margin: 18px 0;

                            > span {

                                font-weight: bolder;
                                color: #089BAB;
                            }
                        }

                        > .product-shop {
                            span {
                                display: flex;
                                align-items: center;
                                font-size: 18px;
                                line-height: 20px;
                                color: #adadad;

                                i {
                                    margin-left: 8px;
                                    font-size: 28px;
                                    color: #089BAB;
                                }
                            }
                        }

                    }
                }

                div.basics-section {
                    display: flex;
                    justify-content: center;
                    align-items: flex-start;
                    background: #FFFFFF;
                    border-radius: 16px;
                }
            }

            div.main-right {
                display: flex;
                flex-direction: column;
                flex-grow: 2;
            }
        }

    }

    .pagination-wrap {
        display: inline-block;

        > div.pagination {
            padding: 0 20px;
            height: 60px;
            background: #FFFFFF;
            border-radius: 10px;
            box-shadow: 3px 10px 20px -6px #b5cdd3;
            display: flex;
            align-items: center;
            margin-bottom: 20px;
        }
    }

    div.main-footer {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        margin-top: 30px;

        > div.btnn {
            box-shadow: 0px 10px 26px -10px #9E9E9E;
            cursor: pointer;
            background: #FF65A5;
            width: 100%;
            text-align: center;
            padding: 12px ;
            color: #FFFFFF;
            transition: all 0.3s linear;
            &:first-child {
                border-radius: 10px 0 0 10px;
                background: #ABD5DB;
            }

            &:last-child {
                border-radius: 0 10px 10px 0;
                background: #4149A9;
            }
            &:hover {
                transition: all 0.3s ease-in-out;
                box-shadow: 0px 10px 26px -10px #000;
            }
        }
    }

    div.foot {
        width: 100%;
        height: 30px;
        margin-top: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 30px;
        font-size: 14px;
        color: #ABD5DB;
    }
</style>
